import { render, staticRenderFns } from "./ApproveDenyItem.vue?vue&type=template&id=8e364eac"
import script from "./ApproveDenyItem.vue?vue&type=script&lang=js"
export * from "./ApproveDenyItem.vue?vue&type=script&lang=js"
import style0 from "./ApproveDenyItem.vue?vue&type=style&index=0&id=8e364eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports